import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { HxOrganizationService, HxUiLabelPipe, OrganizationModel, OrganizationWithUinModel } from 'hx-services';
import { NgOptionComponent, NgSelectComponent } from '@ng-select/ng-select';
import { NgFor } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'app-organization-select',
    templateUrl: './organization-select.component.html',
    styleUrls: ['./organization-select.component.css'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => OrganizationSelectComponent),
            multi: true
        }],
    imports: [NgSelectComponent, FormsModule, NgFor, NgOptionComponent, TranslocoPipe, HxUiLabelPipe]
})
export class OrganizationSelectComponent implements OnInit, ControlValueAccessor {
  @Input() multiple = false;
  @Input() countryId?: number;
  @Output() selectChange = new EventEmitter<OrganizationModel | OrganizationModel[] | undefined>();

  options: OrganizationWithUinModel[] = [];
  isDisabled = false;
  private $selected?: number | number[];

  get selected(): number | number[] | undefined {
    return this.$selected;
  }

  set selected(val: number | number[] | undefined) {
    this.$selected = val;
    this.onChange(val);
  }

  constructor(
    private orgService: HxOrganizationService,
  ) {
  }

  ngOnInit(): void {
    this.getOrganizations();
  }

  onModelChanged(val: any) {
    this.selectChange.emit(this.getSelectedOptions());
  }

  onChange(val: any) {
    // console.log('onChange called', val);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  writeValue(obj?: number | number[]): void {
    this.$selected = obj;
  }

  private getSelectedOptions(): OrganizationModel | OrganizationModel[] | undefined {
    if (!this.multiple) {
      if (this.selected) {
        return this.options.find(p => p.organization.id === this.selected)?.organization;
      } else {
        return undefined;
      }
    } else {
      if (Array.isArray(this.selected)) {
        const ids: number[] = this.selected;
        return this.options.filter(p => ids.includes(p.organization.id)).map(p => p.organization);
      } else {
        return [];
      }
    }
  }

  private async getOrganizations() {
    this.options = await this.orgService.getMyOrganizations({countryId: this.countryId});
  }
}
